import React from 'react';

/**
 * Reusable submit button component
 * @param {Object} props
 * @param {Function} props.onClick - Click handler
 * @param {boolean} props.disabled - Whether button is disabled
 * @param {boolean} props.loading - Whether button is in loading state
 * @param {React.ReactNode} props.children - Button text/content
 */
const SubmitButton = ({ onClick, disabled, loading, children }) => {
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`w-full py-3 px-4 rounded-lg font-medium text-white transition-colors ${
                disabled
                    ? 'bg-gray-400 cursor-not-allowed'
                    : 'bg-cabaza-purple hover:bg-cabaza-pink'
            }`}
        >
            {children}
        </button>
    );
};

export default SubmitButton;
